export default {
  home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  settings: '/settings',
  boards: '/boards',
  board: '/boards/:id',
  notFound: '/404',
  default: '*',
};
